import { IHttpService } from "frontend-core";
import { inject, injectable } from "tsyringe";
import { IStatisticService } from "@/services/IStatisticService";
import {
  Children,
  IAgentTreeStatisticHydra,
  IStatisticDTO,
  Statistic,
} from "@/models/Statistic";
import { IPaginationModel } from "@/models/Pagination";
import { CancelToken } from "axios";

@injectable()
export class StatisticService implements IStatisticService {
  constructor(
    @inject("IHttpService")
    private readonly http: IHttpService,
  ) {}

  async getSales(dateFrom: string, dateTo: string): Promise<Statistic[]> {
    let result: any = null;
    await this.http.api
      .get<IStatisticDTO[]>(`/dashboard/statistic`, {
        params: { dateFrom, dateTo },
      })
      .then(res => {
        result = res.data.map(e => new Statistic(e));
      });

    return result;
  }

  async getAgentChildren(
    userId: string,
    params: any = {},
    cancelToken: CancelToken | undefined = undefined,
  ): Promise<IPaginationModel<Children>> {
    let items: any = null;
    let pagesCount: number = 0;

    if (!params?.itemsPerPage) {
      params.itemsPerPage = 10;
    }

    await this.http.api
      .get<IAgentTreeStatisticHydra>(
        `/agents/${userId}/children_with_statistic`,
        {
          params,
          headers: {
            Accept: "application/ld+json",
          },
          cancelToken,
        },
      )
      .then(res => {
        items = res.data.items.map(e => new Children(e));
        pagesCount = res.data.pagination.perPage;
      });

    return {
      items,
      pagesCount,
    };
  }
}
